module.exports = __webpack_public_path__ + "static/media/yashindustries.4f65caa0.jpg";